import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { white, universalStyles } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  heading: {
    marginTop: 24,
  },
  text: {
    color: white,
  },
  trainingText: {
    marginTop: -10,
    color: white,
  },
}));

const InterpretationPage10 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h6" className={classes.heading}>
        Purpose
      </Typography>
      <ul className={classNames(classes.poslumaList, classes.text)}>
        <li>
          To effectively identify and localize prostate cancer and suspected recurrence through interpretation of PET
          images acquired with POSLUMA by following recommended steps
        </li>
      </ul>
      <Typography className={classes.trainingText}>
        In this training, you will first explore the methodology for interpreting images and then be given the
        opportunity to practice
      </Typography>
      <Typography variant="h6" className={classes.heading}>
        Objectives
      </Typography>
      <ul className={classNames(classes.poslumaList, classes.text)}>
        <li>Learn the steps needed for better identification and interpretation of prostate cancer lesions</li>
        <li>Define the expected physiologic uptake mechanism, incidental findings, and normal variants with POSLUMA</li>
      </ul>
      <Typography variant="h6" className={classes.heading}>
        Explore each step to learn more about image acquisition
      </Typography>
      <ul className={classNames(classes.poslumaList, classes.text)}>
        <li>Proceed to the next page to view the 3 steps</li>
      </ul>
    </>
  );
};

export default InterpretationPage10;
